const proyectos = {
  "BE3883609": {
    titulo: "MEJORAMIENTO CAMINO RURAL, SECTOR EL CAMPO CASERIO SAN ISIDRO, ALDEA SAN FRANCISCO, EL RODEO SM",
    descripcion:
      "MEJORAMIENTO CAMINO RURAL, SECTOR EL CAMPO CASERIO SAN ISIDRO, ALDEA SAN FRANCISCO, EL RODEO SM",
  },
  "BD3569899": {
    titulo: "Aldea Villa Hermosa, Esquipulas Palo Gordo, San Marcos",
    descripcion: "CONSTRUCCIÓN SISTEMA DE AGUA POTABLE EN CANTÓN BARRIOS",
  },
  "BE3883768": {
    titulo: "MEJORAMIENTO CAMINO RURAL SAN NICOLAS",
    descripcion:
      "MEJORAMIENTO DE EDIFICIO DE LA ESCUELA",
  },
  "BE3883762": {
    titulo: "MEJORAMIENTO CALLE RURAL, CASERÍO ENTRE RIOS, EL RODEO, SAN MARCOS",
    descripcion:
      "MEJORAMIENTO CALLE RURAL, CASERÍO ENTRE RIOS, EL RODEO, SAN MARCOS",
  },
};

export default proyectos;
